import React from 'react';
import OptimizationsGrid from './OptimizationsGrid';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

const Optimization = () => {
  return (
    <BasePageContainer>
      <Text
        sx={{
          paddingBottom: '0px' // to offset padding in the chart column labels
        }}
        variant="h4"
      >
        Optimization History
      </Text>
      <div
        style={{
          fontSize: '16px',
          marginTop: 8,
          fontWeight: 400,
          marginBottom: 32
        }}
      >
        The table displays the optimizations executed by Stackline&apos;s automation algorithms or implemented manually
        by ad managers.
      </div>
      <OptimizationsGrid defaultOptimizationType="target" />
    </BasePageContainer>
  );
};

export default Optimization;
